export default "__VITE_ASSET__MWNxxSSr__"